import { adobeModalTrackEvent } from '../common/AdobeTagging/adobeModalTrackEvent';
import { Constants } from '../common/Constants';
import { getRoute } from './map.utils';

export const handleMapClickLocation = async (
  map,
  selectedId,
  longitude,
  latitude,
  locationId,
  locationLng,
  locationLat,
  mapOnPremKey,
  mapKey,
  mapOnPremURL,
  mapLocationUrl,
  mobileScreen,
  setDirections,
  setRouteEndCoords,
  setSelectedId,
  expandedListView = false
) => {
  if (selectedId === locationId && !mobileScreen) {
    return;
  }

  const routeDirections = await getRoute(
    map,
    longitude,
    latitude,
    +locationLng,
    +locationLat,
    false,
    'driving-traffic',
    0,
    mapOnPremKey,
    mapKey,
    mapOnPremURL,
    mapLocationUrl
  );

  if (routeDirections) {
    setDirections(routeDirections);
  }

  setRouteEndCoords([locationLng, locationLat]);
  setSelectedId(locationId);

  if (expandedListView) {
    adobeModalTrackEvent(Constants.LIST_VIEW_NAVIGATION_MODAL);
  } else adobeModalTrackEvent(Constants.MAP_VIEW_NAVIGATION_MODAL);
};
